// extracted by mini-css-extract-plugin
module.exports = {"item":"ChecklistItem_item__PVl8Z","delete":"ChecklistItem_delete__3cddS","title":"ChecklistItem_title__3B9V3"};